import BookingCard from "./BookingCard";
import Modal from "./ModalExample";
import { useState, useCallback, useMemo } from "react";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./create-page";
import EditSesion from "./edit-session";
import {
  IconEdit,
  IconPlus,
  IconChevronDown,
  IconChevronUp,
  IconClock,
} from "@tabler/icons-react";
import CardClickPage from "./card-click";
import { motion } from "framer-motion";
import { LabelProvider } from "contexts/v1/masterData/LabelContext";
import { TripProvider, useTrip } from "contexts/v1/masterData/TripContext";
import { CustomerProvider } from "contexts/v1/masterData/CustomerContext";
import { AgentProvider } from "contexts/v1/masterData/AgentContext";
import { ProductProvider } from "contexts/v1/masterData/ProductContext";
import { GuideProvider } from "../context/GuideContext";
import { BookingProviderV3, useAppV3 } from "contexts/v3/BookingContextV3";
// import { PhotographerProvider } from "contexts/v1/masterData/PhotographerContext";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PaymentMethodProvider } from "contexts/v1/masterData/PaymentMethodContext";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import { useLastSeen } from "./useLastSeen.js";
import { UserProvider } from "contexts/v1/masterData/UserContext";
import { PhotographerProvider } from "../context/PhotographerContext";

// 🔹 Komponen Icon yang lebih efisien
const IconComponent = ({ children, value }) => (
  <span className="text-center text-muted">
    {children}
    {value}
  </span>
);

// 🔹 Komponen Icon yang lebih efisien
const StockIcon = ({ title, value, type }) => {
  // Mapping untuk memilih icon berdasarkan `type`
  const icons = useMemo(
    () => ({
      STOK: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="icon me-1 text-success"
        >
          <path d="M20 11c-.2 0-.4 0-.5.1L17.4 9H20V6l-3.7 1.9L13.4 5H9v2h3.6l2 2H11l-4 2-2-2H0v2h4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4l2 2h3l3.5-6.1 1 1c-.9.7-1.5 1.9-1.5 3.1 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4M4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m16 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
        </svg>
      ),
      BOOKING: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="icon me-1 text-success"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
          />
        </svg>
      ),
      CONFIRMED: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="icon me-1 text-success"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      ),
      // AVAILABLE: <IconChevronDown size={18} className="text-success" />,
      AVAILABLE: (
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          height="1em"
          width="1em"
          className="icon me-1 text-success"
        >
          <path d="M20 11c-.2 0-.4 0-.5.1L17.4 9H20V6l-3.7 1.9L13.4 5H9v2h3.6l2 2H11l-4 2-2-2H0v2h4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4l2 2h3l3.5-6.1 1 1c-.9.7-1.5 1.9-1.5 3.1 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4M4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m16 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
        </svg>
      ),
    }),
    []
  );

  return (
    // <span title={title} className="d-flex align-items-center">
    //   {icons[type]} {/* Ambil icon sesuai dengan `type` */}
    //   <span className="text-muted ms-1">{value}</span>
    // </span>
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`tooltip-${type}`}>
          {title}: {value}
        </Tooltip>
      }
    >
      <span className="d-flex align-items-center" style={{ cursor: "pointer" }}>
        {icons[type]} {/* Icon sesuai tipe */}
        <span className="text-muted ms-1">{value}</span>
      </span>
    </OverlayTrigger>
  );
};

const SessionBlock = ({
  session,
  dataPerTrip,
  refetch,
  trips,
  customers,
  filterOptions,
  userRoles,
  updateFilter,
  onAddLastSeen, // 🔥 terima dari parent
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const { handleSuccess, handleError, showCanvasHandler } = useCanvasHandler();
  const { refetchTrip } = useTrip();
  const { sessions } = useAppV3;

  // 🔹 Gunakan useMemo untuk mencegah perhitungan ulang
  const bookingsForSession = useMemo(
    () => dataPerTrip[session.id] || [],
    [dataPerTrip, session.id]
  );

  //lastSeetBook
  // const { lastSeen, addLastSeen } = useLastSeen("lastSeenBookings", 5);

  // 🔹 Fungsi untuk membuka modal dengan data booking (gunakan useCallback agar tidak dibuat ulang)
  const handleCardClick = useCallback(
    (booking) => {
      setSelectedBooking(booking);
      showCanvasHandler(
        `Reservation/Booking #${booking.id}`,
        <LabelProvider>
          <TripProvider>
            <BookingProviderV3>
              <CustomerProvider>
                <AgentProvider>
                  <GuideProvider>
                    <PhotographerProvider>
                      <CardClickPage
                        onSuccess={() => {
                          handleSuccess(true, "Booking updated successfully");
                          refetchTrip();
                          refetch();
                        }}
                        onError={handleError}
                        initialData={booking}
                        refetchTrip={refetchTrip}
                        userRoles={userRoles}
                        updateFilter={updateFilter}
                        refetch={refetch} // Pass main refetch
                      />
                    </PhotographerProvider>
                  </GuideProvider>
                </AgentProvider>
              </CustomerProvider>
            </BookingProviderV3>
          </TripProvider>
        </LabelProvider>,
        "fullscreen-canvas"
      );
      // 🔥 Tambahkan ini juga: setelah klik card, simpan ke last seen
      if (onAddLastSeen) {
        onAddLastSeen(booking); // 🔥 panggil parent buat update lastSeen
      }
    },
    [showCanvasHandler, handleSuccess, handleError, refetch]
  );

  // 🔹 Fungsi toggle untuk accordion (gunakan useCallback agar tidak dibuat ulang)
  const toggleAccordion = useCallback(() => {
    setOpenIndex((prevIndex) => (prevIndex === "extra" ? null : "extra"));
  }, []);

  return (
    <div
      className={`row mb-3 d-flex rounded-lg text-white border ${session.bg_trip}`}
    >
      {/* Section Last Seen */}
      {/* <div className="mt-3">
        <h5 className="text-muted">Last Seen Bookings</h5>
        <div className="d-flex flex-wrap gap-2">
          {lastSeen.map((item) => (
            <OverlayTrigger
              key={item.id}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-${item.id}`}>
                  Click to view booking
                </Tooltip>
              }
            >
              <button
                className="btn btn-light btn-sm d-flex align-items-center gap-2"
                onClick={() => handleCardClick(item)}
              >
                <IconClock size={14} />
                <span>{item.code}</span>
                <span>{item.guest_name}</span>

              </button>
            </OverlayTrigger>
          ))}
        </div>
      </div> */}

      {/* <pre>{JSON.stringify(lastSeen, null, 2)}</pre> */}

      {/* Sisi kiri */}
      <div className="col-12 col-md-2 p-3 rounded border-end ">
        <h3 className="h5 text-dark">{session.title}</h3>
        <p className="text-muted">{session.time}</p>

        {/* <div className="d-flex gap-3 mt-3 align-items-center"> */}
        <div className="row d-flex g-2 mt-3 align-items-center">
          {[
            { title: "STOK", value: session?.stocks?.stocks, type: "STOK" },
            {
              title: "BOOKING",
              value: session?.stocks?.booking,
              type: "BOOKING",
            },
            {
              title: "AVAILABLE",
              value: session?.stocks?.in_track,
              type: "AVAILABLE",
            },
            {
              title: "CONFIRMED-FINISHED",
              value: session?.stocks?.arrived,
              type: "CONFIRMED",
            },
          ].map((item, index) => (
            <div className="col-lg-6 col-md-6 col-sm-3 col-3">
              <StockIcon key={index} {...item} />
            </div>
          ))}
        </div>

        {/* Tombol Edit & Booking */}
        <div className="d-flex flex-column mt-3">
          <button
            className="btn btn-white text-warning w-100"
            title="Edit Session"
            onClick={() => {
              showCanvasHandler(
                "Edit Session",
                <EditSesion
                  onSuccess={() => {
                    handleSuccess(true, "Session updated successfully");
                    refetchTrip();
                  }}
                  onError={handleError}
                  date={session.date}
                  session={session}
                />
              );
            }}
          >
            <IconEdit size={18} className="me-2" />
            Edit
          </button>

          <button
            className="btn btn-white text-info w-100 mt-2"
            onClick={() => {
              showCanvasHandler(
                "Create Reservation",
                <ProductProvider>
                  <AgentProvider>
                    <UserProvider>
                      <LabelProvider>
                        <TripProvider>
                          <PaymentMethodProvider>
                            <CreatePage
                              onSuccess={() => {
                                handleSuccess(
                                  true,
                                  "Reservation created successfully"
                                );
                                refetchTrip();
                                refetch();
                              }}
                              onError={handleError}
                              sessions={sessions}
                              customers={customers}
                              session={session}
                              filterOptions={filterOptions}
                            />
                          </PaymentMethodProvider>
                        </TripProvider>
                      </LabelProvider>
                    </UserProvider>
                  </AgentProvider>
                </ProductProvider>,
                "fullscreen-canvas"
              );
            }}
          >
            <IconPlus size={18} className="me-2" />
            Booking
          </button>
        </div>
      </div>

      {/* Sisi kanan */}
      <div className="col-md-10 p-3 rounded">
        <div className="row g-2">
          {/* Tampilkan 5 BookingCard pertama */}
          {/* {bookingsForSession.slice(0, 12).map((booking) => (
            <div
              className="col-lg-2 col-md-3 col-sm-4 col-6"
              // style={{
              //   flex: "0 0 calc(20% - 10px)", // 20% lebar dengan jarak antar kolom
              //   marginBottom: "10px",
              //   marginLeft: "10px",
              // }}
            >
              <BookingCard
                key={booking.id}
                booking={booking}
                session={session}
                onClick={handleCardClick}
              />
            </div>
          ))} */}
          {bookingsForSession.slice(0, 12).map((booking) => {
            const isRestrictedStatus =
              booking.status === "played" || booking.status === "finished";

            return (
              <div
                className="col-lg-2 col-md-3 col-sm-4 col-6"
                key={booking.id}
              >
                {isRestrictedStatus ? (
                  <PermissionMiddleware
                    allowedPermissions={["view_played_finish"]}
                  >
                    <BookingCard
                      booking={booking}
                      session={session}
                      onClick={handleCardClick}
                    />
                  </PermissionMiddleware>
                ) : (
                  <BookingCard
                    booking={booking}
                    session={session}
                    onClick={handleCardClick}
                  />
                )}
              </div>
            );
          })}

          {/* print json bookingsForSession */}
          {/* <pre>{JSON.stringify(bookingsForSession, null, 2)}</pre> */}
        </div>

        {/* Akordion untuk kartu tambahan */}
        {bookingsForSession.length > 12 && (
          <div className="mt-3">
            <div
              onClick={toggleAccordion}
              className="p-2 bg-white text-blue rounded d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer" }}
            >
              <span>
                {openIndex === "extra"
                  ? "Hide"
                  : `Show ${bookingsForSession.length - 12} More Bookings`}
              </span>
              <span>
                {openIndex === "extra" ? (
                  <IconChevronUp size={18} />
                ) : (
                  <IconChevronDown size={18} />
                )}
              </span>
            </div>

            {/* Konten Akordion */}
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                openIndex === "extra"
                  ? { height: "auto", opacity: 1 }
                  : { height: 0, opacity: 0 }
              }
              transition={{ duration: 0.5 }}
              className="overflow-hidden"
            >
              <div className="row g-2">
                {/* {bookingsForSession.slice(12).map((booking) => (
                  <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                    <BookingCard
                      key={booking.id}
                      booking={booking}
                      session={session}
                      onClick={handleCardClick}
                    />
                  </div>
                ))} */}
                {bookingsForSession.slice(12).map((booking) => {
                  const isRestrictedStatus =
                    booking.status === "played" ||
                    booking.status === "finished";

                  return (
                    <div
                      className="col-lg-2 col-md-3 col-sm-4 col-6"
                      key={booking.id}
                    >
                      {isRestrictedStatus ? (
                        <PermissionMiddleware
                          allowedPermissions={["view_played_finish"]}
                        >
                          <BookingCard
                            booking={booking}
                            session={session}
                            onClick={handleCardClick}
                          />
                        </PermissionMiddleware>
                      ) : (
                        <BookingCard
                          booking={booking}
                          session={session}
                          onClick={handleCardClick}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </motion.div>
          </div>
        )}

        {bookingsForSession.length === 0 && (
          <p className="text-muted">No bookings in this Trip</p>
        )}
      </div>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedSession={session}
        bookingData={selectedBooking}
      />
    </div>
  );
};

export default SessionBlock;
